<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Consolidado Indemnizaciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                label-for="fdesde"
                :horizontal="false"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormulario.fdesde"
                    :disabled="campoBloqueado('fdesde', 'datosFormulario')"
                  ></datepicker>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fdesde }}</span>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                label-for="fhasta"
                :horizontal="false"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormulario.fhasta"
                    :disabled="campoBloqueado('fhasta', 'datosFormulario')"
                  ></datepicker>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fhasta }}</span>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                :label="crearLabel('Moneda', 'codmoneda', 'datosFormulario')"
                label-for="codmoneda"
              >
                <b-form-select
                  :options="valMonedas"
                  v-model="datosFormulario.codmoneda"
                  :disabled="campoBloqueado('codmoneda', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codmoneda }}</span>
              </b-form-group>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Consolidado Indemnizaciones</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

import XLSX from "xlsx";

export default {
  name: "TareasActividades",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "Consolidado Indemnizaciones",
      //titlesDinamic: [],
      titles: [
        {
          prop: "producto",
          label: "Producto",
          minwidth:'150',
          align: "left"
        },
        {
          prop: "mto_nom",
          label: "Monto Nom.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "can_nom",
          label: "Cantidad Nom.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "pro_nom",
          label: "Promedio Nom.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "mto_inn",
          label: "Monto Inn.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "can_inn",
          label: "Cantidad Inn.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "pro_inn",
          label: "Promedio Inn.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "mto_gar",
          label: "Monto Gar.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "can_gar",
          label: "Cantidad Gar.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "pro_gar",
          label: "Promedio Gar.",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "mto_gen",
          label: "Monto General",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "can_gen",
          label: "Cantidad General",
          minwidth:'150',
          align: "right"
        },
        {
          prop: "pro_gen",
          label: "Promedio General",
          minwidth:'150',
          align: "right"
        }
      ],
      filters: [
        {
          prop: ["producto",
                "mto_nom",
                "can_nom",
                "pro_nom",
                "mto_inn",
                "can_inn",
                "pro_inn",
                "mto_gar",
                "can_gar",
                "pro_gar",
                "mto_gen",
                "can_gen",
                "pro_gen"
                 ],
          value: ""
        }
      ],


      datosFormulario: {},
      valMonedas: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight:600
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];

      return apiInformes
        .pre_insercion_consolidadoindem(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.codmoneda = lista_data[i]["codmoneda"];
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
          }
         
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de monedas
        var tiposMonedas = new Array();
          var lista_tipos_monedas = response.data.monedas;
          for(var i = 0; i < lista_tipos_monedas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_monedas[i]["codmoneda"];
              obj.text = lista_tipos_monedas[i]["codmoneda"];
              tiposMonedas.push(obj);
          }
          this.valMonedas = tiposMonedas;

          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiInformes
        .recuperar_consolidadoindem(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta, 
          this.datosFormulario.codmoneda
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          console.log(this.data);
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property != "producto" && row[column.property]) {
        return this.$numeral(row[column.property]).format();
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Consolidado Indemnizaciones</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Desde "+this.convierteFecha(this.datosFormulario.fdesde)+" Hasta "+this.convierteFecha(this.datosFormulario.fhasta)+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td colspan=1 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Tipo</td>\n";
        cuerpo += "<td colspan=3 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Nominado</td>\n";
        cuerpo += "<td colspan=3 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Innominado</td>\n";
        cuerpo += "<td colspan=3 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Garantía</td>\n";
        cuerpo += "<td colspan=3 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Total General</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Producto</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Monto</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Cantidad</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Promedio</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Monto</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Cantidad</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Promedio</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Monto</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Cantidad</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Promedio</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Monto General</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Cantidad General</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>Promedio General</td>\n";
      cuerpo += "</tr>\n";

      

      //Data bloque 1
      for (var key in this.data) {
          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["producto"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["mto_nom"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["can_nom"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["pro_nom"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["mto_inn"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["can_inn"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["pro_inn"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["mto_gar"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["can_gar"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["pro_gar"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["mto_gen"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["can_gen"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["pro_gen"]).format('0,0.00')+"</td>\n";
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};

</script>
